import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@core/services';
import { map, tap } from 'rxjs';

export const noAuthGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  return authService.check().pipe(
    tap((checked) => {
      if (checked) {
        void router.navigate(['']);
      }
    }),
    map((checked) => !checked)
  );
};
